import React from 'react';
import { formatDetailedTime, formatDate, getBrandingText } from '../templateUtils';

const HoloTemplate = ({
  language = 'zh',
  calculatedDays = 0,
  relationshipLabel = '在一起',
  detailedTime = null,
  anniversaryDate = null,
  anniversaryType = 'couple',
  quote = ''
}) => {
  const s = 3.375;
  const heartGradId = 'holo-tmpl-heart-grad';
  const textGradId = 'holo-tmpl-text-grad';
  const brandGradId = 'holo-tmpl-brand-grad';

  return (
    <div
      style={{
        width: '1080px', height: '1350px',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
        overflow: 'hidden', position: 'relative',
        fontFamily: 'Arial, sans-serif', boxSizing: 'border-box'
      }}
    >
      {/* 全息光暈 */}
      <div style={{ position: 'absolute', top: '15%', left: '10%', width: `${150 * s}px`, height: `${150 * s}px`, borderRadius: '50%', background: 'conic-gradient(from 0deg, #ff006e, #8338ec, #3a86ff, #06ffa5, #ffbe0b, #ff006e)', opacity: 0.15, filter: `blur(${40 * s}px)` }} />
      <div style={{ position: 'absolute', bottom: '20%', right: '15%', width: `${135 * s}px`, height: `${135 * s}px`, borderRadius: '50%', background: 'conic-gradient(from 90deg, #06ffa5, #3a86ff, #8338ec, #ff006e, #ffbe0b, #06ffa5)', opacity: 0.12, filter: `blur(${35 * s}px)` }} />

      {/* 隱藏 SVG defs */}
      <svg width="0" height="0" style={{ position: 'absolute' }}>
        <defs>
          <linearGradient id={heartGradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ff006e" /><stop offset="25%" stopColor="#8338ec" />
            <stop offset="50%" stopColor="#3a86ff" /><stop offset="75%" stopColor="#06ffa5" />
            <stop offset="100%" stopColor="#ffbe0b" />
          </linearGradient>
          <linearGradient id={textGradId} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#ff006e" /><stop offset="33%" stopColor="#8338ec" />
            <stop offset="66%" stopColor="#3a86ff" /><stop offset="100%" stopColor="#06ffa5" />
          </linearGradient>
          <linearGradient id={brandGradId} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#ff006e" /><stop offset="33%" stopColor="#8338ec" />
            <stop offset="66%" stopColor="#3a86ff" /><stop offset="100%" stopColor="#06ffa5" />
          </linearGradient>
        </defs>
      </svg>

      {/* 主內容區 */}
      <div style={{
        position: 'relative', zIndex: 10, height: '100%',
        display: 'flex', flexDirection: 'column',
        padding: `${28 * s}px ${22 * s}px ${22 * s}px ${22 * s}px`
      }}>

        {/* 頂部愛心圓圈 */}
        <div style={{ textAlign: 'center', marginBottom: `${16 * s}px` }}>
          <div style={{
            display: 'inline-block', padding: `${10 * s}px`,
            background: 'rgba(131,56,236,0.15)', borderRadius: '50%',
            border: `${2 * s}px solid rgba(255,190,11,0.5)`,
            boxShadow: `0 0 ${20 * s}px rgba(255,0,110,0.4), 0 0 ${35 * s}px rgba(131,56,236,0.3)`
          }}>
            <svg xmlns="http://www.w3.org/2000/svg" width={`${48 * s}`} height={`${48 * s}`} viewBox="0 0 24 24">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill={`url(#${heartGradId})`} />
            </svg>
          </div>
        </div>

        {/* 中間內容 */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>

          {/* 主數字 — SVG text 渲染漸變 */}
          <div style={{ lineHeight: '1', marginBottom: `${8 * s}px`, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="1036" height={`${80 * s}`} viewBox={`0 0 1036 ${80 * s}`}>
              <defs>
                <linearGradient id={`${textGradId}-inner`} x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#ff006e" /><stop offset="25%" stopColor="#8338ec" />
                  <stop offset="50%" stopColor="#3a86ff" /><stop offset="75%" stopColor="#06ffa5" />
                  <stop offset="100%" stopColor="#ffbe0b" />
                </linearGradient>
              </defs>
              <text x="50%" y="85%" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="800" fontSize={`${72 * s}`} fill={`url(#${textGradId}-inner)`}>
                {calculatedDays}
              </text>
            </svg>
          </div>

          <div style={{ fontSize: `${16 * s}px`, fontWeight: '600', color: '#06ffa5', marginBottom: `${18 * s}px`, textShadow: `0 0 ${12 * s}px rgba(6,255,165,0.6), 0 0 ${24 * s}px rgba(6,255,165,0.3)` }}>
            {language === 'zh' ? `${relationshipLabel}的日子` : `days ${relationshipLabel}`}
          </div>

          {detailedTime && (
            <div style={{ display: 'inline-block', fontSize: `${12 * s}px`, color: '#ffffff', fontWeight: '500', marginBottom: `${14 * s}px`, padding: `${6 * s}px ${14 * s}px`, background: 'rgba(131,56,236,0.2)', border: `${1 * s}px solid rgba(255,190,11,0.4)`, borderRadius: `${20 * s}px`, boxShadow: `0 0 ${15 * s}px rgba(255,0,110,0.3)`, alignSelf: 'center' }}>
              {formatDetailedTime(detailedTime, language)}
            </div>
          )}

          {quote && (
            <div style={{ fontSize: `${10 * s}px`, color: '#d4b3ff', fontStyle: 'italic', lineHeight: '1.6', paddingLeft: `${16 * s}px`, paddingRight: `${16 * s}px`, textShadow: `0 0 ${8 * s}px rgba(131,56,236,0.5)` }}>
              "{quote}"
            </div>
          )}
        </div>

        {/* 底部信息 */}
        <div style={{
          textAlign: 'center', paddingTop: `${12 * s}px`, paddingBottom: `${10 * s}px`,
          background: 'rgba(131,56,236,0.15)', border: `${1 * s}px solid rgba(255,190,11,0.35)`,
          borderRadius: `${12 * s}px`, boxShadow: `0 0 ${20 * s}px rgba(255,0,110,0.25)`
        }}>
          {anniversaryDate && (
            <div style={{ fontSize: `${9 * s}px`, color: '#b3d9ff', marginBottom: `${6 * s}px`, textShadow: `0 0 ${6 * s}px rgba(58,134,255,0.5)` }}>
              {formatDate(anniversaryDate, language)}
            </div>
          )}
          <svg xmlns="http://www.w3.org/2000/svg" width="800" height={`${16 * s}`} viewBox={`0 0 800 ${16 * s}`} style={{ display: 'block', margin: `0 auto ${4 * s}px auto` }}>
            <defs>
              <linearGradient id={`${brandGradId}-inner`} x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#ff006e" /><stop offset="33%" stopColor="#8338ec" />
                <stop offset="66%" stopColor="#3a86ff" /><stop offset="100%" stopColor="#06ffa5" />
              </linearGradient>
            </defs>
            <text x="50%" y="90%" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize={`${10 * s}`} fill={`url(#${brandGradId}-inner)`} letterSpacing={`${1 * s}`}>
              {getBrandingText(anniversaryType, language).toUpperCase()}
            </text>
          </svg>
          <div style={{ fontSize: `${8 * s}px`, color: '#06ffa5', textShadow: `0 0 ${6 * s}px rgba(6,255,165,0.5)` }}>
            lovedays.homy.hk
          </div>
        </div>
      </div>
    </div>
  );
};

export default HoloTemplate;